module.exports = __webpack_public_path__ + "static/media/summer-garden-sm.ce5ba471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/summer-garden-sm.jpg
// module id = 172
// module chunks = 12